function makeElementDraggable(elementContent, elementHeader, params = null) {
    let makeContentFixed = params?.makeContentFixed || false;
    let movement = params?.movement || "auto"; // default is auto which move x and y axis, if x, means move horizontally only and y vertically only
    let moveUpCallbackFunction = params?.moveUpCallbackFunction || null;
    let isPreventHeaderOffScreen = params?.isPreventHeaderOffScreen || false;

    const onMouseMoveElement = e => {
        // NOTE: Force element to have fixed position
        if (makeContentFixed) {
            elementContent.style.position = "fixed";
        } else {
            elementContent.style.position = "absolute";
        }

        const isMoveXAxis = movement === "auto" || movement === "x";
        const isMoveYAxis = movement === "auto" || movement === "y";
        // Handle when mouse move:
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        if (isMoveYAxis) {
            let newTop = elementContent.offsetTop - pos2;

            if (isPreventHeaderOffScreen) {
                const limitBottom = document.documentElement.clientHeight - 30;
                if (newTop < 0) {
                    newTop = 0;
                } else if (newTop > limitBottom) {
                    newTop = limitBottom; // 30px enough to prevent the whole element content been hidden
                }
            }
            elementContent.style.top = `${newTop}px`;
        }
        if (isMoveXAxis) {
            let newLeft = elementContent.offsetLeft - pos1;

            if (isPreventHeaderOffScreen) {
                const limitLeft = document.documentElement.clientWidth - 30;
                if (newLeft < 0) {
                    newLeft = 0;
                } else if (newLeft > limitLeft) {
                    newLeft = limitLeft; // 30px enough to prevent the whole element content been hidden
                }
            }

            elementContent.style.left = `${newLeft}px`;
        }
    };

    const onMouseDownElement = e => {
        // Handle when mouse click element header:
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;

        document.addEventListener("mousemove", onMouseMoveElement);
        document.addEventListener("mouseup", onMouseUpElement);
    };

    const onMouseUpElement = () => {
        // Handle when mouse move mouse button is released:
        if (
            moveUpCallbackFunction &&
            typeof moveUpCallbackFunction === "function"
        ) {
            moveUpCallbackFunction();
        }

        document.removeEventListener("mousemove", onMouseMoveElement);
        document.removeEventListener("mouseup", onMouseUpElement);
    };

    const onElementClose = () => {
        elementHeader.style.cursor = "default";
        elementHeader.removeEventListener("mousedown", onMouseDownElement);
    };

    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;

    if (elementHeader) {
        // Initiate mouse event to element
        elementHeader.style.position = "relative";
        elementHeader.style.cursor = "move";

        elementHeader.addEventListener("mousedown", onMouseDownElement);
        // NOTE: return a function to remove all event listener
        return onElementClose;
    }
}

export default makeElementDraggable;
